import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {APP_ENVIRONMENT} from "../../../chat-common/src/lib/services/environment.service";
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import {getFirestore, provideFirestore} from "@angular/fire/firestore";
import {getDatabase, provideDatabase} from "@angular/fire/database";
import {getAuth, provideAuth} from "@angular/fire/auth";
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {environment} from '../environments/environment';
import { DatePipe } from '@angular/common';
import {AccountLibraryModule, environmentDev, environmentProd, environmentStage} from '@bellabeat/account-library';

const env = environment.app === 'local' ? environmentDev : (environment.app === 'stage' ? environmentStage : environmentProd);
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    AccountLibraryModule.configure(env),
  ],
  providers: [
    { provide: APP_ENVIRONMENT, useValue: environment },
    DatePipe,

    provideFirebaseApp(() => initializeApp(environment.firebase)),  // Use environment config
    provideFirestore(() => getFirestore()),
    provideDatabase(() => getDatabase()),
    provideAuth(() => getAuth()),
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
